module.exports = __webpack_public_path__ + "assets/img/mecha-btn-8382d2ed.png";